import axios from 'axios';
import Cookies from 'universal-cookie';
import {browserHistory} from 'react-router';

class APIKey {
  constructor() {
    this.keyUpdated = new Date();
    this.key = null;
    this.ax = null;
  }

  getKey() {
    let now = new Date();
    const timeDiff = Math.abs(now - this.keyUpdated) / 36e5;
    // console.log('timediff: ', timeDiff);

    if(this.key === null || timeDiff > 0.8) {
      const cookies = new Cookies();
      let key = cookies.get('ndAPIKey');
      if(key) {
        this.setKey(key);
        return Promise.resolve(key);
      } else {
        const pathname = browserHistory.getCurrentLocation().pathname;
        if(pathname.includes('reset') || pathname.includes('form') || pathname.includes('setup')){
          return Promise.resolve(undefined);
        }else {
          browserHistory.replace("/login"+window.location.search);

          return Promise.reject("No Key was found");
        }
      }
    } else {
      return Promise.resolve(this.key);
    }
  }

  setKey(key) {
    this.key = key;
  }

  get(endpoint) {
    return this.getKey().then(key => {
      // console.log("Using key ", this.key);
      return axios.get(process.env.API_URL + endpoint, {headers:{"X-API-KEY":key}}).then(res => {
        // console.log(res);
        return res;
      });
    })
    .catch(err => {
      console.log(err);
      throw err;
    });
  }

}

export default (new APIKey);



// WEBPACK FOOTER //
// ./src/actions/APIManager.js